<template>
    <mySubPage>
        <div slot="header">
            <myNav>组织入驻审批</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="130px">
            <el-form-item :label="$t('logo_img')" prop="img_lnk">
                <img style="width: 300px;height:300px" :src="formData.img_lnk">
            </el-form-item>
            <el-form-item :label="$t('build_img')" prop="build_img_lnk">
                <img style="width: 450px;height:270px" :src="formData.build_img_lnk" v-if="formData.build_img_lnk != ''">
                <div v-else>{{$t('no_set')}}</div>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('code')" prop="org_code">
                        <el-input v-model="formData.org_code" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('cname')" prop="org_cname">
                        <el-input v-model="formData.org_cname" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('org_mod_cname')" prop="mod_id">
                        <el-select class="fillw" v-model="formData.mod_id" :placeholder="$t('select')" disabled>
                            <el-option :label="item.mod_cname"  :value="item.mod_id" v-for="item in mods" :key="item.mod_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('fee')" prop="fee_cat_id">
                        <el-select class="fillw" v-model="formData.fee_cat_id" :placeholder="$t('select')" disabled>
                            <el-option :label="item.cat_cdesc"  :value="item.cat_id" v-for="item in fee" :key="item.cat_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('join_type_cname')" prop="join_type">
                        <el-select class="fillw" v-model="formData.join_type" :placeholder="$t('select')" disabled>
                            <el-option :label="item.type_cname"  :value="item.join_type" v-for="item in join_type" :key="item.join_type"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item v-if="['M3'].includes(formData.mod_cat)" :label="$t('mod2_org')">
                <el-radio-group v-model="formData.mod2_org_id" disabled>
                    <el-radio :label="item.org_id" :value="item.org_id" v-for="item in mod2_org" :key="item.org_id">{{item.org_cname}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('link_cname')" prop="link_cname">
                        <el-input v-model="formData.link_cname" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('link_mobile')" prop="link_mobile">
                        <el-input v-model="formData.link_mobile" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('cu_cname')" prop="cu_cname">
                        <el-input v-model="formData.cu_cname" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('cu_mobile')" prop="cu_mobile">
                        <el-input v-model="formData.cu_mobile" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('cu_time_area')" prop="cu_time_area">
                        <el-input v-model="formData.cu_time_area" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="['M3'].includes(formData.mod_cat)">
                <el-col :span="8">
                    <el-form-item label="信誉消费模式" prop="cr_cat">
                        <el-select class="fillw" v-model="formData.cr_cat" :placeholder="$t('select')" disabled>
                            <el-option :label="item.value"  :value="item.key" v-for="item in cr_cat" :key="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="信誉额度" prop="cr_qty">
                        <el-input v-model="formData.cr_qty" disabled :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="每日低于" prop="day_cr_qty_min">
                        <el-input v-model="formData.day_cr_qty_min" disabled>
                            <span slot="append">自动恢复<span class="f-blue">(填空不恢复)</span></span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--省市区选择-->
            <el-form-item :label="$t('addr2')" prop="addrLabel">
                <el-cascader class="fillw" :options="addrData" trigger="click" :filterable="true" disabled
                             v-model="formData.addrLabel" ref="ref_addr" :props="{value:'label'}"></el-cascader>
            </el-form-item>
            <!--详细地址-->
            <el-form-item :label="$t('addr')" prop="addr">
                <el-input v-model="formData.addr" disabled></el-input>
            </el-form-item>
            <el-row v-if="false">
                <el-col :span="12">
                    <el-form-item :label="$t('org_admin_code')" prop="org_admin_code">
                        <el-input v-model="formData.org_admin_code" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('admin_code')" prop="admin_code">
                        <el-input v-model="formData.admin_code" :placeholder="$t('user_code')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <el-input class="w350 mg-right5" v-model="rwData.rw_remark">
                    <span slot="prepend">{{$t('no_rw_remark')}}</span>
                </el-input>
                <el-button class="mg-right10" type="primary" @click="rw" v-if="rwData.rw_remark.trim() == ''">{{$t('rw_ok')}}</el-button>
                <el-button type="warning" @click="noRw">{{$t('no_rw')}}</el-button>
                <div class="flex-box-bd"></div>
                <el-button @click="cancel">{{$t('cancel')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
import myCropImg from '../../../components/myCropImg'
import addr from '../../../utils/addr/index'
export default {
    components:{
        myCropImg
    },
    data:function(){
        return{
            op: this.$base.getRequest().op,
            relist:false,
            formData: {
                app_id:'',
                img_lnk: "",
                build_img_lnk: "",
                org_code: "",
                org_cname: "",
                mod_cat: "",
                mod_id: "",
                fee_cat_id:'',
                join_type:'',
                cr_cat:'',
                cr_qty:'',
                day_cr_qty_min:'',
                link_cname: "",
                link_mobile: "",
                cu_cname: "",
                cu_mobile: "",
                cu_time_area: "",
                prov: "",
                city: "",
                area: "",
                addrLabel:[],
                addr: "",
                lng:'0', // 经度
                lat:'0',  // 维度
                admin_code: "",
                org_admin_code: "",
                mod2_org_id:'',
            },
            rule: {
                admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
            },
            addrData: [],
            mods:[],
            join_type: [],
            cr_cat: [],
            fee: [],
            mod2_org: [],
            rwData:{
                app_id:'',
                admin_code: "",
                rw_remark:''
            }
        }
    },
    mounted: function(){
        this.$parent.$parent.show_subview = true;
        this.formData.app_id = this.$base.getRequest().id;
        this.rwData.app_id = this.formData.app_id;
        this.getInfo();

        setTimeout(() => {
            this.addrData = addr.getAddrData()
        }, 500);
    },
    methods:{
        cancel: function(){
            this.$base.linkBack();
        },
        getInfo: function(){
            var data = {
                app_id: this.formData.app_id
            };
            this.$base.showLoading();
            this.$request.sendPost("rw-orgapp/before-upd",data,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.mods = data.mods;
                    this.join_type = data.join_type;
                    this.cr_cat = data.cr_cat;
                    this.fee = data.fee;
                    this.mod2_org = data.mod2_org;
                    this.formData = this.$base.leftJson(this.formData,data.info);
                    this.formData.addrLabel=[this.formData.prov,this.formData.city,this.formData.area];
                    this.formData.admin_code = 'admin';
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        rw: function(){
            this.formData.admin_code = this.formData.admin_code.trim();
            if(this.formData.admin_code == ''){
                this.$base.alertErr(this.$t('input_admin_code'));
                return;
            }
            this.rwData.admin_code = this.formData.admin_code;

            this.$base.rw(this,'rw-orgapp/rw');
        },
        noRw: function(){
            this.$base.noRw(this,'rw-orgapp/no-rw');
        }
    },
    beforeDestroy: function () {
        this.$parent.$parent.show_subview = false;
        this.$parent.$parent.relist = this.relist;
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/rw/orgapp/save.vue